var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVmwareHypervisor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M7.169 35.221h22.442v-2.805h-22.442v2.805zM7.169 24h22.442v-2.805h-22.442v2.805zM41.533 33.818c0-1.162-0.942-2.104-2.104-2.104s-2.104 0.942-2.104 2.104 0.942 2.104 2.104 2.104 2.104-0.942 2.104-2.104zM7.169 12.779h22.442v-2.805h-22.442v2.805zM41.533 22.597c0-1.162-0.942-2.104-2.104-2.104s-2.104 0.942-2.104 2.104 0.942 2.104 2.104 2.104 2.104-0.942 2.104-2.104zM41.533 11.377c0-1.162-0.942-2.104-2.104-2.104s-2.104 0.942-2.104 2.104 0.942 2.104 2.104 2.104 2.104-0.942 2.104-2.104zM43.636 29.61v8.416h-39.273v-8.416h39.273zM43.636 18.39v8.416h-39.273v-8.416h39.273zM43.636 7.169v8.416h-39.273v-8.416h39.273z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmwareHypervisor);
export default __webpack_public_path__ + "static/media/vmware-hypervisor.552fbde50d555afb4550009ce5a052b9.svg";
export { ForwardRef as ReactComponent };